import { React, useState } from 'react';
import { useForm, yupResolver } from '@mantine/form';
import { Button, Code, SimpleGrid, Select, Loader, MultiSelect, Modal, Center, Text, TooltipFloating, Group, MultiSelectProps } from '@mantine/core';
import useCreate from './useCreate';
import { DateTimePicker } from '@mantine/dates';
import { object } from "yup";
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { IconEye, IconFlagQuestion, IconInfoCircle } from '@tabler/icons-react';
import * as Yup from 'yup';
import { useDisclosure } from '@mantine/hooks';
import CustomApiSelect from '../../../../components/customApiSelect/CustomApiSelect';
import { getAgencies, getAllUsers } from '../../../../api/agencyAdmin/match';

const userSchema = Yup.object().shape({
    user_name: Yup.string()
        .required('Please select a user'),
    opponent_usernames: Yup.array()
        .of(Yup.string())
        .min(1, 'Please select at least one opponent'),

    level_id: Yup.string()
        .required('Level is required'),



    start_at: Yup.date()
        .required('Start date and time is required')
        .typeError('Invalid date'),
    end_at: Yup.date()
        .required('End date and time is required')
        .typeError('Invalid date')
        .min(
            Yup.ref('start_at'),
            'End date must be later than start date'
        ),
});


const languageData = [
    { value: "Afrikaans", label: "Afrikaans" },
    { value: "Albanian", label: "Albanian" },
    { value: "Amharic", label: "Amharic" },
    { value: "Arabic", label: "Arabic" },
    { value: "Armenian", label: "Armenian" },
    { value: "Azerbaijani", label: "Azerbaijani" },
    { value: "Basque", label: "Basque" },
    { value: "Belarusian", label: "Belarusian" },
    { value: "Bengali", label: "Bengali" },
    { value: "Bosnian", label: "Bosnian" },
    { value: "Bulgarian", label: "Bulgarian" },
    { value: "Catalan", label: "Catalan" },
    { value: "Cebuano", label: "Cebuano" },
    { value: "Chinese", label: "Chinese" },
    { value: "Corsican", label: "Corsican" },
    { value: "Croatian", label: "Croatian" },
    { value: "Czech", label: "Czech" },
    { value: "Danish", label: "Danish" },
    { value: "Dutch", label: "Dutch" },
    { value: "English", label: "English" },
    { value: "Esperanto", label: "Esperanto" },
    { value: "Estonian", label: "Estonian" },
    { value: "Finnish", label: "Finnish" },
    { value: "French", label: "French" },
    { value: "Frisian", label: "Frisian" },
    { value: "Galician", label: "Galician" },
    { value: "Georgian", label: "Georgian" },
    { value: "German", label: "German" },
    { value: "Greek", label: "Greek" },
    { value: "Gujarati", label: "Gujarati" },
    { value: "Haitian Creole", label: "Haitian Creole" },
    { value: "Hausa", label: "Hausa" },
    { value: "Hawaiian", label: "Hawaiian" },
    { value: "Hebrew", label: "Hebrew" },
    { value: "Hindi", label: "Hindi" },
    { value: "Hmong", label: "Hmong" },
    { value: "Hungarian", label: "Hungarian" },
    { value: "Icelandic", label: "Icelandic" },
    { value: "Igbo", label: "Igbo" },
    { value: "Indonesian", label: "Indonesian" },
    { value: "Irish", label: "Irish" },
    { value: "Italian", label: "Italian" },
    { value: "Japanese", label: "Japanese" },
    { value: "Javanese", label: "Javanese" },
    { value: "Kannada", label: "Kannada" },
    { value: "Kazakh", label: "Kazakh" },
    { value: "Khmer", label: "Khmer" },
    { value: "Korean", label: "Korean" },
    { value: "Kurdish (Kurmanji)", label: "Kurdish (Kurmanji)" },
    { value: "Kyrgyz", label: "Kyrgyz" },
    { value: "Lao", label: "Lao" },
    { value: "Latin", label: "Latin" },
    { value: "Latvian", label: "Latvian" },
    { value: "Lithuanian", label: "Lithuanian" },
    { value: "Luxembourgish", label: "Luxembourgish" },
    { value: "Macedonian", label: "Macedonian" },
    { value: "Malagasy", label: "Malagasy" },
    { value: "Malay", label: "Malay" },
    { value: "Malayalam", label: "Malayalam" },
    { value: "Maltese", label: "Maltese" },
    { value: "Maori", label: "Maori" },
    { value: "Marathi", label: "Marathi" },
    { value: "Mongolian", label: "Mongolian" },
    { value: "Myanmar (Burmese)", label: "Myanmar (Burmese)" },
    { value: "Nepali", label: "Nepali" },
    { value: "Norwegian", label: "Norwegian" },
    { value: "Nyanja (Chichewa)", label: "Nyanja (Chichewa)" },
    { value: "Odia (Oriya)", label: "Odia (Oriya)" },
    { value: "Pashto", label: "Pashto" },
    { value: "Persian", label: "Persian" },
    { value: "Polish", label: "Polish" },
    { value: "Portuguese", label: "Portuguese" },
    { value: "Punjabi", label: "Punjabi" },
    { value: "Romanian", label: "Romanian" },
    { value: "Russian", label: "Russian" },
    { value: "Samoan", label: "Samoan" },
    { value: "Scots Gaelic", label: "Scots Gaelic" },
    { value: "Serbian", label: "Serbian" },
    { value: "Sesotho", label: "Sesotho" },
    { value: "Shona", label: "Shona" },
    { value: "Sindhi", label: "Sindhi" },
    { value: "Sinhala", label: "Sinhala" },
    { value: "Slovak", label: "Slovak" },
    { value: "Slovenian", label: "Slovenian" },
    { value: "Somali", label: "Somali" },
    { value: "Spanish", label: "Spanish" },
    { value: "Sundanese", label: "Sundanese" },
    { value: "Swahili", label: "Swahili" },
    { value: "Swedish", label: "Swedish" },
    { value: "Tagalog (Filipino)", label: "Tagalog (Filipino)" },
    { value: "Tajik", label: "Tajik" },
    { value: "Tamil", label: "Tamil" },
    { value: "Telugu", label: "Telugu" },
    { value: "Thai", label: "Thai" },
    { value: "Turkish", label: "Turkish" },
    { value: "Ukrainian", label: "Ukrainian" },
    { value: "Urdu", label: "Urdu" },
    { value: "Uzbek", label: "Uzbek" },
    { value: "Vietnamese", label: "Vietnamese" },
    { value: "Welsh", label: "Welsh" },
    { value: "Xhosa", label: "Xhosa" },
    { value: "Yiddish", label: "Yiddish" },
    { value: "Yoruba", label: "Yoruba" },
    { value: "Zulu", label: "Zulu" },
];
dayjs.extend(utc);
dayjs.extend(timezone);

function Demo() {
    const {
        createMutation
    } = useCreate()

    const [type, setType] = useState('');
    const [agency, setAgency] = useState('');


    const [submittedValues] = useState('');




    const form = useForm({
        mode: 'uncontrolled',
        initialValues: {

            opponent_usernames: [],
            user_name: "",
            level_id: "",
            match_style_id: "",
            start_at: "",
            end_at: "",


        },
        validate: yupResolver(userSchema)
    });

    const { getInputProps, values } = form ?? {}
    const handleCreate = form.onSubmit(async (data) => {
        const formData = new FormData();
        // formData.append("theme_id", data?.theme_id);
        formData.append("opponent_usernames", data?.opponent_usernames);
        formData.append("user_name", data?.user_name);
        formData.append("level_id", data?.level_id);
        formData.append("match_style_id", data?.match_style_id ?? "");
        // formData.append("country", data?.country);
        formData.append("language", data?.language ?? "");
        formData.append("start_time", dayjs(data?.start_at).utc().format('YYYY-MM-DD HH:mm:ss'));
        formData.append("end_time", dayjs(data?.end_at).utc().format('YYYY-MM-DD HH:mm:ss'));
        createMutation.mutate(formData)
    })

    const {
        // ThemeQuery: {
        // data, isPending, isError, isRefetching },
        LevelQuery: {
            data: levelData, isPending: levelIsPending, isError: levelIsError, isRefetching: levelIsRefetching
        },
        userQuery: {
            data: userData, isPending: userIsPending, isError: userIsError, isRefetching: userIsRefetching
        },
        userAllQuery: {
            data: userAllData, isPending: userAllIsPending, isError: userAllIsError, isRefetching: userAllIsRefetching
        },
        matchStyleQuery: {
            data: matchStyleData, isPending: matchStyleIsPending, isError: matchStyleIsError, isRefetching: matchStyleIsRefetching
        },
        // countryQuery: {
        //     data: countryData, isPending: countryIsPending, isError: countryIsError, isRefetching: countryIsRefetching
        // }
    } = useCreate()




    // Fetch data from API with optional search query


    // handle search change: when searchValue changes, refetch data



    // console.log({ selectedFile });


    const optionsFilter = ({ options, search }) => {
        const splittedSearch = search.toLowerCase().trim().split(' ');
        return options?.filter((option) => {
            const words = option.label.toLowerCase().trim().split(' ');
            return splittedSearch.every((searchWord) => words.some((word) => word.includes(searchWord)) && option?.value !== form.getValues()?.user_name);
        });

    };
    const TikTokLink = ({ username }) => {
        return (
            <a href={`https://www.tiktok.com/${username}`} target="_blank" rel="noopener noreferrer">
                <IconEye />
            </a>
        );
    };
    const renderMultiSelectOption = ({ option }) => (
        <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", flex: 1 }}>
            <Text size="sm">{option.value}</Text>
            <TikTokLink username={option.value} />
        </div>
    );

    const [opened, { open, close }] = useDisclosure(false);
    console.log(type);


    return (
        <>
            <Group>
                <h1>Create New Match Offer</h1>
                <a target='_blank' href="https://famelive-edu.eu/en/support-agencies
"><TooltipFloating label="Information"><IconInfoCircle /></TooltipFloating></a></Group>

            <SimpleGrid
                cols={{ base: 1, sm: 2, lg: 2 }}
            // breakpoints={[{ maxWidth: 768, cols: 1 }]}
            >


                <Select
                    label="Select your creator"
                    placeholder="Pick one"
                    searchable
                    // onSearchChange={(value) => setSearchValue(value)}
                    data={userData ?? []}
                    nothingFound={userIsPending ? <Loader size="xs" /> : 'No items found'}
                    clearable
                    onChange={value => {
                        // setSelectedUser(value)
                        console.log({ value });

                        form.setFieldValue("user_name", value)
                        form.setFieldValue("opponent_usernames", [])
                    }}
                />


                <Select
                    label="Select your type of opponent list"
                    placeholder="Pick one"
                    searchable
                    // onSearchChange={(value) => setSearchValue(value)}
                    data={[{
                        value: "all-users",
                        label: "All Users"
                    }, {
                        value: "agency-users",
                        label: "My Agency Users"
                    }, {
                        value: "other-agency-users",
                        label: "Other Agency Users"
                    }]}
                    nothingFound={userIsPending ? <Loader size="xs" /> : 'No items found'}
                    clearable
                    onChange={setType}
                />


                {

                    //  If selected value is agency
                    type == 'other-agency-users' && <CustomApiSelect
                        labelKey='tiktok_username'
                        label="Agencies"
                        placeholder={"Select Agency"}
                        queryFn={(props) =>
                            getAgencies({
                                ...props,
                            })
                        }
                        onChange={setAgency}
                    />
                }


                <CustomApiSelect
                    key={form.getValues()?.user_name + type + agency}
                    labelKey='tiktok_username'
                    required
                    maxValues={3}
                    label="Select opponents (max 3)"
                    placeholder={type == 'other-agency-users' ? "Please select first agency" : "Pick value"}
                    isMulti={true}
                    queryFn={(props) =>
                        getAllUsers({
                            agency_id: agency,
                            type: type,
                            ...props,
                        })
                    }
                    filterDataLogic={(data) => data?.label !== form.getValues()?.user_name}
                    // queryFn={getStateList}
                    // renderOption={renderMultiSelectOption}
                    // filter={optionsFilter}
                    {...getInputProps("opponent_usernames")}

                />

                {/* <MultiSelect
                    maxValues={3}
                    label="Select opponents (max 3)"
                    placeholder={true ? "Please select first agency" : "Pick value"}
                    // disabled
                    data={userAllData ?? []}
                    clearable
                    searchable
                    renderOption={renderMultiSelectOption}
                    filter={optionsFilter}
                    {...getInputProps("opponent_usernames")}

                /> */}

                {/* <Select
                    label="Select Theme"
                    placeholder="Pick one"
                    searchable
                    // onSearchChange={(value) => setSearchValue(value)}
                    data={data ?? []}
                    nothingFound={isPending ? <Loader size="xs" /> : 'No items found'}
                    clearable
                    {...getInputProps("theme_id")}


                /> */}



                <Select
                    label="Select Level"
                    placeholder="Pick one"
                    searchable
                    // onSearchChange={(value) => setSearchValue(value)}
                    data={levelData ?? []}
                    nothingFound={levelIsPending ? <Loader size="xs" /> : 'No items found'}
                    clearable
                    {...getInputProps("level_id")}


                />

                <Select
                    label="Match Style"
                    placeholder="Pick one"
                    searchable
                    // onSearchChange={(value) => setSearchValue(value)}
                    data={matchStyleData ?? []}
                    nothingFound={matchStyleIsPending ? <Loader size="xs" /> : 'No items found'}
                    clearable
                    {...getInputProps("match_style_id")}


                />

                {/* <Select
                    label="Country"
                    placeholder="Pick one"
                    searchable
                    // onSearchChange={(value) => setSearchValue(value)}
                    data={countryData ?? []}
                    nothingFound={countryIsPending ? <Loader size="xs" /> : 'No items found'}
                    clearable
                    {...getInputProps("country")}


                /> */}

                <Select
                    label="Language"
                    placeholder="Pick one"
                    searchable
                    data={languageData}
                    nothingFound="No items found"
                    clearable
                    {...getInputProps("language")}
                />

                <DateTimePicker label="Start date and time" placeholder="Pick date and time" timeFormat="h:mm aa" {...getInputProps("start_at")} />

                <DateTimePicker label="End date and time" placeholder="Pick date and time" timeFormat="h:mm aa" formTarget='' {...getInputProps("end_at")} />






            </SimpleGrid>
            <Button type="submit" mt="md" onClick={handleCreate} loading={createMutation?.isPending}>
                Submit
            </Button>
            &nbsp;
            <Button type="button" mt="md" color="red" onClick={open} >
                Return
            </Button>

            <Modal opened={opened} onClose={close}
                centered
                title="Confirm">

                <Text>Are you sure you want to leave this page without saving?</Text>


                <Center mt={"md"}>
                    <Button onClick={() => window.history.back()}
                    >Confirm</Button>
                </Center>

            </Modal >

            {submittedValues && (
                <Code block mt="md">
                    {submittedValues}
                </Code>
            )}
        </>
    );
}



export default Demo;
